import { signal } from '@preact/signals-react'

export const officeModalData = signal([])
export const sitesModalData = signal([])
export const reportSearchesModalId = signal(null)